import type { AppRouteRecordRaw } from '@/types/router'
import { ROUTE_NAMES } from '@/types/router'

// 基础路由 - 所有环境都需要
import { commonRoutes } from '@/router/routes/common'

// 根据环境变量动态导入路由模块
async function getEnvRoutes(): Promise<AppRouteRecordRaw[]> {
  if (import.meta.env.VITE_ROUTES_MODULE) {
    // 构建时环境替换
    const moduleName = import.meta.env.VITE_ROUTES_MODULE
    if (moduleName === 'cn') {
      const { cnRoutes } = await import('./cn')
      return cnRoutes
    } else if (moduleName === 'ww') {
      // ww环境现在返回懒加载函数，需要调用它
      const { wwRoutes } = await import('./ww')
      return await wwRoutes()
    }
  } else {
    const isWW = import.meta.env.VITE_APP_REGION === 'ww'
    // 开发环境回退逻辑 - 根据区域判断
    if (isWW) {
      const { wwRoutes } = await import('./ww')
      return await wwRoutes()
    } else {
      const { cnRoutes } = await import('./cn')
      return cnRoutes
    }
  }
  return []
}

// 创建路由配置函数
export async function createRoutes(): Promise<AppRouteRecordRaw[]> {
  const envRoutes = await getEnvRoutes()
  return [
    ...commonRoutes,
    ...envRoutes,
  ]
}

// 导出路由名称常量
export { ROUTE_NAMES }

// 导出获取环境路由的函数
export { getEnvRoutes } 